import { render, staticRenderFns } from "./DashboardPlansCard.vue?vue&type=template&id=36c3173d&"
import script from "./DashboardPlansCard.vue?vue&type=script&lang=js&"
export * from "./DashboardPlansCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports